import React from 'react'

const DatabaseIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" fill="none">
            <path d="M21.9999 5.5C13.8966 5.5 7.33325 8.78167 7.33325 12.8333C7.33325 16.885 13.8966 20.1667 21.9999 20.1667C30.1033 20.1667 36.6666 16.885 36.6666 12.8333C36.6666 8.78167 30.1033 5.5 21.9999 5.5ZM7.33325 16.5V22C7.33325 26.0517 13.8966 29.3333 21.9999 29.3333C30.1033 29.3333 36.6666 26.0517 36.6666 22V16.5C36.6666 20.5517 30.1033 23.8333 21.9999 23.8333C13.8966 23.8333 7.33325 20.5517 7.33325 16.5ZM7.33325 25.6667V31.1667C7.33325 35.2183 13.8966 38.5 21.9999 38.5C30.1033 38.5 36.6666 35.2183 36.6666 31.1667V25.6667C36.6666 29.7183 30.1033 33 21.9999 33C13.8966 33 7.33325 29.7183 7.33325 25.6667Z" fill="black" />
        </svg>
    )
}

export default DatabaseIcon